import { useSelector } from "react-redux";
import store from "../../store";

// Taxonomy settings (categories, statuses, campaignTypes, state lists) are
// scoped per DOMAIN, not per user. The active domain lives on auth.user.domain
// and the super-admin domain switcher updates it, so settings follow whichever
// domain is selected; regular users only ever have their own domain.

export const useSettingsDomain = () =>
  useSelector((state) => String(state.auth.user?.domain || "").trim());

export const getSettingsDomain = () =>
  String(store.getState()?.auth?.user?.domain || "").trim();

export const settingsScope = (domain) => (domain ? { domain } : {});
